export const DEFAULT_SCORE_TITLE = 'Untitled';
export const DEFAULT_SCORE_ARTIST = 'Artist';
